document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-card__media--swipeable').forEach(card => {
    const track = card.querySelector('.product-card__carousel-track');
    if (!track) return;

    const slides = track.querySelectorAll('.product-card__carousel-slide');
    if (slides.length <= 1) return;

    let currentIndex = 0;
    let startX = 0;
    let startY = 0;

    card.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    card.addEventListener('touchend', (e) => {
      const deltaX = e.changedTouches[0].clientX - startX;
      const deltaY = e.changedTouches[0].clientY - startY;

      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 40) {
        if (deltaX < 0 && currentIndex < slides.length - 1) {
          currentIndex++;
        } else if (deltaX > 0 && currentIndex > 0) {
          currentIndex--;
        }
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
      }
    }, { passive: true });
  });
});